import React, { createContext, useContext } from 'react';

// Создаем сам контекст с начальным значением null
const FormBuilderContext = createContext(null);

/**
 * Кастомный хук для удобного доступа к функциям и данным конструктора.
 * Любой дочерний компонент сможет вызвать его, чтобы получить, например, deleteQuestion.
 */
export const useFormBuilder = () => {
    const context = useContext(FormBuilderContext);
    // Проверка, что компонент находится внутри провайдера
    if (!context) {
        throw new Error('useFormBuilder must be used within a FormBuilderProvider');
    }
    return context;
};

// Экспортируем сам Provider, чтобы использовать его в FormBuilder.jsx
export const FormBuilderProvider = FormBuilderContext.Provider;
